const addressStatuses = {
  undeliverable: 'UNDELIVERABLE',
  unableManuallyValidate: 'UNABLE_MANUALLY_VALIDATE',
} as const


export default addressStatuses
